type IconProps = React.ComponentProps<'svg'>

export function BoldIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.2504 11.8C15.74 11.5018 16.1532 11.0934 16.4571 10.6073C16.7609 10.1212 16.9469 9.57077 17.0004 9C17.0097 8.48388 16.9172 7.971 16.7282 7.49063C16.5392 7.01027 16.2575 6.57184 15.899 6.20039C15.5406 5.82894 15.1124 5.53174 14.6391 5.32578C14.1658 5.11981 13.6565 5.00911 13.1404 5H6.65039V19H13.6504C14.1415 18.9948 14.6269 18.8929 15.0786 18.7001C15.5304 18.5073 15.9397 18.2274 16.2833 17.8764C16.6269 17.5253 16.898 17.1101 17.0811 16.6543C17.2642 16.1985 17.3557 15.7112 17.3504 15.22V15.1C17.3507 14.4071 17.1533 13.7285 16.7813 13.144C16.4093 12.5594 15.8782 12.0931 15.2504 11.8ZM8.65039 7H12.8504C13.2766 6.98681 13.6966 7.10428 14.0541 7.33665C14.4116 7.56902 14.6894 7.90517 14.8504 8.3C15.0133 8.82779 14.9606 9.39859 14.7039 9.88765C14.4472 10.3767 14.0073 10.7443 13.4804 10.91C13.2758 10.97 13.0636 11.0003 12.8504 11H8.65039V7ZM13.2504 17H8.65039V13H13.2504C13.6766 12.9868 14.0966 13.1043 14.4541 13.3367C14.8116 13.569 15.0894 13.9052 15.2504 14.3C15.4133 14.8278 15.3606 15.3986 15.1039 15.8877C14.8472 16.3767 14.4073 16.7443 13.8804 16.91C13.6758 16.97 13.4636 17.0003 13.2504 17Z"
        fill="currentColor"
      />
    </svg>
  )
}

export function ItalicsIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.7605 9H13.7605L11.5605 19H9.56055L11.7605 9ZM13.4405 5C13.2428 5 13.0494 5.05865 12.885 5.16853C12.7205 5.27841 12.5924 5.43459 12.5167 5.61732C12.441 5.80004 12.4212 6.00111 12.4598 6.19509C12.4983 6.38907 12.5936 6.56725 12.7334 6.70711C12.8733 6.84696 13.0515 6.9422 13.2455 6.98079C13.4394 7.01937 13.6405 6.99957 13.8232 6.92388C14.006 6.84819 14.1621 6.72002 14.272 6.55557C14.3819 6.39112 14.4405 6.19778 14.4405 6C14.4405 5.73478 14.3352 5.48043 14.1477 5.29289C13.9601 5.10536 13.7058 5 13.4405 5Z"
        fill="currentColor"
      />
    </svg>
  )
}

export function UnderlineIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19 20V22H5V20H19ZM16 13.215C15.9671 13.875 15.7711 14.5165 15.4297 15.0823C15.0883 15.6481 14.6121 16.1205 14.0435 16.4572C13.475 16.794 12.8318 16.9847 12.1716 17.0122C11.5114 17.0397 10.8546 16.9033 10.26 16.615C9.57464 16.3185 8.99341 15.8241 8.59077 15.1952C8.18813 14.5663 7.98242 13.8315 8 13.085V5.005H6V13.215C6.03383 14.1564 6.28885 15.0766 6.74442 15.9012C7.19998 16.7257 7.84329 17.4314 8.62227 17.9611C9.40125 18.4908 10.294 18.8296 11.2283 18.9502C12.1625 19.0707 13.1121 18.9696 14 18.655C15.1811 18.2613 16.2059 17.5012 16.9252 16.485C17.6446 15.4689 18.0211 14.2498 18 13.005V5.005H16V13.215ZM16 5H18H16ZM8 5H6H8Z"
        fill="currentColor"
      />
    </svg>
  )
}

export function LinkIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11 17H7C5.67392 17 4.40215 16.4732 3.46447 15.5355C2.52678 14.5979 2 13.3261 2 12C2 10.6739 2.52678 9.40215 3.46447 8.46447C4.40215 7.52678 5.67392 7 7 7H11V9H7C6.20435 9 5.44129 9.31607 4.87868 9.87868C4.31607 10.4413 4 11.2044 4 12C4 12.7956 4.31607 13.5587 4.87868 14.1213C5.44129 14.6839 6.20435 15 7 15H11V17ZM17 7H13V9H17C17.7956 9 18.5587 9.31607 19.1213 9.87868C19.6839 10.4413 20 11.2044 20 12C20 12.7956 19.6839 13.5587 19.1213 14.1213C18.5587 14.6839 17.7956 15 17 15H13V17H17C18.3261 17 19.5979 16.4732 20.5355 15.5355C21.4732 14.5979 22 13.3261 22 12C22 10.6739 21.4732 9.40215 20.5355 8.46447C19.5979 7.52678 18.3261 7 17 7ZM16 11H8V13H16V11Z"
        fill="currentColor"
      />
    </svg>
  )
}

export function OrderedListIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.5 16H4.5V16.5H3.5V17.5H4.5V18H2.5V19H5.5V15H2.5V16ZM3.5 9H4.5V5H2.5V6H3.5V9ZM2.5 11H4.3L2.5 13.1V14H5.5V13H3.7L5.5 10.9V10H2.5V11ZM7.5 6V8H21.5V6H7.5ZM7.5 18H21.5V16H7.5V18ZM7.5 13H21.5V11H7.5V13Z"
        fill="currentColor"
      />
    </svg>
  )
}

export function EmojiIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.991 3.00001C10.2114 3.00179 8.47218 3.53114 6.99333 4.52116C5.51447 5.51117 4.36232 6.9174 3.68251 8.56209C3.0027 10.2068 2.82575 12.0161 3.17404 13.7613C3.52232 15.5066 4.38019 17.1094 5.63922 18.3671C6.89825 19.6249 8.50192 20.4812 10.2475 20.8277C11.9931 21.1743 13.8022 20.9955 15.4462 20.3141C17.0902 19.6326 18.4953 18.4791 19.4839 16.9992C20.4724 15.5194 21 13.7797 21 12C21.0006 10.8172 20.7679 9.64587 20.3152 8.55309C19.8626 7.46031 19.1989 6.46752 18.3621 5.63156C17.5253 4.7956 16.5318 4.13288 15.4386 3.68132C14.3454 3.22976 13.1738 2.99824 11.991 3.00001ZM12 19C10.6155 19 9.26216 18.5895 8.11101 17.8203C6.95987 17.0511 6.06266 15.9579 5.53285 14.6788C5.00303 13.3997 4.86441 11.9922 5.13451 10.6344C5.4046 9.27651 6.07129 8.02923 7.05026 7.05026C8.02922 6.07129 9.2765 5.40461 10.6344 5.13451C11.9922 4.86442 13.3997 5.00304 14.6788 5.53285C15.9579 6.06267 17.0511 6.95987 17.8203 8.11102C18.5895 9.26216 19 10.6155 19 12C19.0003 12.9193 18.8194 13.8297 18.4677 14.6791C18.116 15.5285 17.6004 16.3003 16.9503 16.9503C16.3003 17.6004 15.5285 18.116 14.6791 18.4677C13.8297 18.8194 12.9193 19.0003 12 19ZM15.105 13.8H16.608C16.2464 14.728 15.6131 15.5252 14.7909 16.0873C13.9687 16.6493 12.996 16.95 12 16.95C11.0041 16.95 10.0313 16.6493 9.20912 16.0873C8.38692 15.5252 7.75358 14.728 7.392 13.8H8.895C9.20819 14.3469 9.66027 14.8014 10.2055 15.1175C10.7507 15.4335 11.3698 15.6 12 15.6C12.6302 15.6 13.2493 15.4335 13.7945 15.1175C14.3397 14.8014 14.7918 14.3469 15.105 13.8ZM7.5 9.75001C7.5 9.48301 7.57918 9.222 7.72752 8.99999C7.87586 8.77798 8.0867 8.60495 8.33338 8.50277C8.58006 8.40059 8.8515 8.37386 9.11338 8.42595C9.37525 8.47804 9.6158 8.60661 9.8046 8.79542C9.9934 8.98422 10.122 9.22476 10.1741 9.48664C10.2262 9.74851 10.1994 10.02 10.0972 10.2666C9.99506 10.5133 9.82203 10.7242 9.60002 10.8725C9.37802 11.0208 9.11701 11.1 8.85 11.1C8.49196 11.1 8.14858 10.9578 7.89541 10.7046C7.64224 10.4514 7.5 10.1081 7.5 9.75001ZM13.8 9.75001C13.8 9.48301 13.8792 9.222 14.0275 8.99999C14.1759 8.77798 14.3867 8.60495 14.6334 8.50277C14.8801 8.40059 15.1515 8.37386 15.4134 8.42595C15.6753 8.47804 15.9158 8.60661 16.1046 8.79542C16.2934 8.98422 16.422 9.22476 16.4741 9.48664C16.5262 9.74851 16.4994 10.02 16.3972 10.2666C16.2951 10.5133 16.122 10.7242 15.9 10.8725C15.678 11.0208 15.417 11.1 15.15 11.1C14.792 11.1 14.4486 10.9578 14.1954 10.7046C13.9422 10.4514 13.8 10.1081 13.8 9.75001Z"
        fill="currentColor"
      />
    </svg>
  )
}
